import React, { useContext } from 'react';
import { RateProps } from '../components/Offramp/api/rate';
import { RampData } from '../components/v4/commonApi/ramp';

export interface Store {
  error: boolean;
  setError?: Function;
  stateV4: RampData | undefined;
  setStateV4: Function;
  rate: RateProps | undefined;
  setRate: Function;
  merchant?: any;
  setMerchant?: Function;
}

const store: Store = {
  stateV4: undefined,
  setStateV4: () => {},
  error: false,
  setError: () => {},
  rate: undefined,
  setRate: () => {},
  merchant: undefined,
  setMerchant: () => {},
};

const OnrampPaymentContext = React.createContext(store);
OnrampPaymentContext.displayName = 'Onramp Payment Context';
export const useOnrampPaymentContext = () => useContext(OnrampPaymentContext);
export default OnrampPaymentContext;
